module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter_fm1",
    attrs: {
      "id": "c16"
    }
  }, [_c('span', {
    staticClass: "chapter_fm1"
  }, [_vm._v("c. 850")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Gunpowder")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Gunpowder probably was discovered by alchemists trying to transmute metals or extend life rather than by weapons engineers seeking an explosive. A Chinese military compendium from 1044 listed a number of different recipes for gunpowder, showing that it had been the subject of a lot of action-packed research and development by the middle of the Song dynasty, but the first known mention comes from a mid-ninth-century Taoist text, which stressed its dangerously flammable nature. Sulfur was of great importance in "), _c('strong', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c17"
    }
  }, [_vm._v("alchemy")])]), _vm._v(", and any lab of the time would have had charcoal around for fuel. The third key ingredient—the oxidizer potassium nitrate—was available as the naturally occurring mineral niter (also known as "), _c('em', [_vm._v("saltpeter")]), _vm._v(") or as crystals around deposits of bat guano in caves. Whoever first combined these powders and exposed the resulting mixture to a flame must have immediately realized that they were onto something big. Extending human life, though, turned out not to be gunpowder’s strong point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Knowledge of the new weapon diffused through China and past its borders, and the Mongol invasions of the thirteenth century spread the news even farther, from India to Europe. The Chinese kept raising the amount of potassium nitrate in their gunpowder as time went on, producing bigger explosions all the time. Early artillery shells, exploding arrows, and a variety of alarming bomb designs show up in several Chinese military manuscripts. In his "), _c('em', [_vm._v("Treatise on Horsemanship and Stratagems of War")]), _vm._v(" (c. 1280), detailing 107 different explosive mixtures, Syrian chemist Hasan al-Rammah referred to potassium nitrate as “Chinese snow.” European militaries adopted gunpowder quickly: the first illustration of a firearm—a primitive metal cannon known as a "), _c('em', [_vm._v("pot-de-fer")]), _vm._v(" (French for “iron pot”) with an enormous arrow emerging from its barrel—appeared in a 1326 manuscript by the English scholar Walter de Milemete. For better or worse, it has been with us ever since.")]), _vm._v(" "), _c('p', {
    staticClass: "seealso"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c13"
    }
  }, [_vm._v("Greek Fire (c. 672)")]), _vm._v(", "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c17"
    }
  }, [_vm._v("Alchemy (c. 900)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nitroglycerine (1847)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PEPCON Explosion (1988)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "dis_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/045.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An explosion of gunpowder shells during the 1274 Mongol invasion of Japan, illustrated in a scroll commissioned some twenty years after the battle.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-704ae85b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c16.vue
// module id = 123
// module chunks = 0